import { Component, OnInit } from '@angular/core';
import { BasicComponent } from '../../basic-component';
import { DockingService } from '../docking.service';
import { IDockingContext } from '../../../../model/docking';
import { asyncScheduler, shareReplay, takeUntil, throttleTime } from 'rxjs';
import { EnvService } from '../../configuration/env.service';

@Component({
    selector: 'app-docking',
    templateUrl: './docking.component.html'
})
export class DockingComponent extends BasicComponent implements OnInit {
    dockingContext: IDockingContext;

    constructor(private readonly dockingService: DockingService, private readonly envService: EnvService) {
        super();
    }

    ngOnInit(): void {
        const envDebounceTime: number = this.envService.config.debounceTime;
        this.dockingService
            .getDockingContext()
            .pipe(
                takeUntil(this.componentDestroyed$),
                throttleTime(Math.max(envDebounceTime, 250), asyncScheduler, { leading: true, trailing: true }),
                shareReplay()
            )
            .subscribe(dockingContext => {
                this.dockingContext = dockingContext;
            });
    }
}
